"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwitterEmbed = void 0;
const XEmbed_1 = require("./XEmbed");
/**
 * @deprecated Twitter was rebranded to the name X in July 2023. Use `XEmbed` instead.
 */
exports.TwitterEmbed = XEmbed_1.XEmbed;
